module.exports = __webpack_public_path__ + "img/strategy_martin_grey.710747d2.svg";